import { ACCOUNT_API_FORGOT_PASSWORD, ACCOUNT_API_PROFILE, ACCOUNT_API_RESET_PASSWORD, ACCOUNT_API_SIGN_IN, ACCOUNT_API_UPDATE_PASSWORD } from './../../shared/constants/api-endpoint';
import { apiClient } from "shared/plugins/http-service";
import { IChangedPasswordModel, ICurrentUserModel, IForgotPasswordModel, ILoginRequestModel, ILoginResponseModel, IResetPasswordModel } from "./account.models";

export const signInAPI = async (model: ILoginRequestModel) => {
  return await apiClient.postHttp<ILoginResponseModel>(
    `${ACCOUNT_API_SIGN_IN}`,
     model,
     undefined,
     false
  );
};
export const forgotPasswordAPI = async (model: IForgotPasswordModel) => {
  return await apiClient.postHttp(
    `${ACCOUNT_API_FORGOT_PASSWORD}`,
     model,
     undefined,
     false
  );
};
export const resetPasswordAPI = async (model: IResetPasswordModel) => {
  return await apiClient.postHttp(
    `${ACCOUNT_API_RESET_PASSWORD}`,
     model,
     undefined,
     false
  );
};

export const updatePasswordAPI = async (model: IChangedPasswordModel) => {
  return await apiClient.putHttp(
    `${ACCOUNT_API_UPDATE_PASSWORD}`,
     model,
  );
};

export const getProfileAPI = async () => {
  return await apiClient.getHttp<ICurrentUserModel>(
    `${ACCOUNT_API_PROFILE}`,
  );
};